import { useEffect, useState } from "react";
import { useAuth } from "../context/authContext";

export const useValidSubscription = () => {
  const [hasValidSubscription, setHasValidSubscription] = useState(false);
  const {
    state: { user, subscription },
  } = useAuth();

  useEffect(() => {
    let isValid = false;
    if (user) {
      isValid =
        user !== null &&
        user.subscription_expired === false &&
        (user.secondary_user || user.is_on_free_trial || subscription !== null);
    }

    setHasValidSubscription(isValid);
  }, [user, subscription]);

  return hasValidSubscription;
};
